import {useEffect, useRef} from 'react';
import {clearRequiredFieldError, resetRequiredFieldError} from "../../utils/project-utils.js";
import {useRequiredFieldError} from "../../hooks/use-required-field-error.js";

const InputRadio = ({ className, label, disabled, id, name, onChange, checked, value, inputRef, required, invalid = false }) => {
    const radioRef = useRef(null);
    const isRequired = required || (typeof label === "string" && label.trim().endsWith("*"));
    const labelText = typeof label === "string" ? label.replace(/\s*\*\s*$/, "") : label;
    const requiredFieldInvalid = useRequiredFieldError(radioRef, isRequired);
    const hasRequiredError = !disabled && !checked && (invalid || requiredFieldInvalid);

    useEffect(() => {
        if (isRequired && checked) clearRequiredFieldError(radioRef.current);
    }, [checked]);

    useEffect(() => {
        if (disabled) resetRequiredFieldError(radioRef.current);
    }, [disabled]);

    const setRadioRef = (element) => {
        radioRef.current = element;

        if (typeof inputRef === "function") inputRef(element);
        else if (inputRef) inputRef.current = element;
    };

    return (
        <div className={["flex items-center text-gray-600", className].join(" ")}>
            <input
                ref={setRadioRef}
                id={id}
                name={name}
                type="radio"
                value={value}
                checked={checked}
                disabled={disabled}
                required={isRequired}
                data-required-field={isRequired || undefined}
                aria-invalid={hasRequiredError}
                onChange={onChange}
                className={`w-4 h-4 bg-gray-100 border-gray-300 rounded-full transition-[border-color,border-width] duration-150 ease-out ${hasRequiredError ? "!border-[2px] !border-[#dc2626]" : ""}`}
            />

            <label htmlFor={id} className="ms-2 text-[13px]">
                {labelText}{isRequired ? <span className="ml-0.5">*</span> : null}
            </label>
        </div>
    );
};

export default InputRadio;